// @flow
import { Logger } from 'utils/logger'

type UnexpectedErrorPayload = {|
  +error: mixed,
  logger?: typeof Logger,
|}

export const unexpectedErrorAlert = ({ error, logger }: UnexpectedErrorPayload): void => {
  logger ? logger.error(error) : Logger.error(error)
}
